import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { IReviewsSummary } from "./reviewsAggregate";
import { IReviewWidgetOptionBase } from "./reviewWidgetOptionBase";
import { IReviewWidgetSummaryComponentOption, ReviewWidgetSummaryComponentOption } from "./reviewWidgetSummaryComponentOption";

export interface IReviewWidgetSummaryFilterComponentBase extends IInstanceComponentBase {
    reviewsSummary: IReviewsSummary;
}

export abstract class ReviewWidgetSummaryFilterComponentBase extends InstanceComponentBase implements IReviewWidgetSummaryFilterComponentBase {
    public componentOptions : IReviewWidgetOptionBase[];
    public reviewsSummary: IReviewsSummary = {} as IReviewsSummary;
    public selectedRating: number;
    
    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);
        
        this.setSelectedRating();
        this.setReviewSummaryFromReviewSummaryAttribute();
        this.reviewWidgetSummaryComponentOptionsFactory();
    }

    reviewWidgetSummaryComponentOptionsFactory():void{
         try {
            console.log('ReviewWidgetSummaryFilterComponentBase: reviewWidgetSummaryComponentOptionFactory - Started');
            
            this.componentOptions = [];
            
            let optionElements: NodeListOf<HTMLElement> | null = this.htmlElement.querySelectorAll(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetRatingsOption.ratingsOption)) as NodeListOf<HTMLElement>;
            
            if(optionElements !== null){
                for (let i = 0; i < optionElements.length; i += 1) {
                    let summaryOption: IReviewWidgetOptionBase =this.componentOptionFactory(optionElements[i]);
                    this.componentOptions.push(summaryOption);
                }
            }
            
            console.log('ReviewWidgetSummaryFilterComponentBase: reviewWidgetSummaryComponentOptionFactory - Finished');
        } catch (error) {
            console.log("ReviewWidgetSummaryFilterComponentBase: reviewWidgetSummaryComponentOptionFactory ERROR: ", error);
        }
    }


    abstract componentOptionFactory(currentHtmlElement: HTMLElement): IReviewWidgetOptionBase;

    getStateForIsDisabledFilterOption(currentRating: number):boolean{
        let isDisabled = true;
        if(currentRating === 1 && this.reviewsSummary.totalOneStars > 0){
             isDisabled = false;
             return isDisabled;
        }
        if(currentRating === 2 && this.reviewsSummary.totalTwoStars > 0){
            isDisabled = false;
             return isDisabled;
        }
        if(currentRating === 3 && this.reviewsSummary.totalThreeStars > 0){
            isDisabled = false;
             return isDisabled;
        }
        if(currentRating === 4 && this.reviewsSummary.totalFourStars > 0){
            isDisabled = false;
             return isDisabled;
        }
        if(currentRating === 5 && this.reviewsSummary.totalFiveStars > 0){
            isDisabled = false;
             return isDisabled;
        }
        if(currentRating === -1){
            isDisabled = false;
             return isDisabled;
        }
        return isDisabled;
    }

    getStateForIsSelectedFilterOption(currentRating: number): boolean{
        return currentRating === this.selectedRating;
    }

    setSelectedRating(): void {
        this.selectedRating = +this.htmlElement.getAttribute(AttributeEnums.ReviewComponents.reviewWidgetSelectedRating);
    }

    writeToSelectedRating(selectedRating: number): void {
        this.htmlElement.setAttribute(AttributeEnums.ReviewComponents.reviewWidgetSelectedRating, selectedRating.toString());
    }

    updateSelectedRating(selectedRating: number): void {
        this.writeToSelectedRating(selectedRating);
        this.setSelectedRating();
    }

    setReviewSummaryFromReviewSummaryAttribute(){
        let reviewSummaryValueString = this.htmlElement.getAttribute(AttributeEnums.ReviewWidgetSummaryFilterComponentBase.ReviewsSummary);
        let reviewsSummaryArray = reviewSummaryValueString.split(',');
        this.reviewsSummary = { 
            totalOneStars: +reviewsSummaryArray[0], 
            totalTwoStars: +reviewsSummaryArray[1],
            totalThreeStars: +reviewsSummaryArray[2],
            totalFourStars: +reviewsSummaryArray[3],
            totalFiveStars: +reviewsSummaryArray[4]

         } as IReviewsSummary;
    }

    writeToReviewSummaryFromReviewSummaryAttribute(reviewsSummary: IReviewsSummary): void {
        let reviewsSummaryString: string = `${reviewsSummary.totalOneStars},${reviewsSummary.totalTwoStars},${reviewsSummary.totalThreeStars},${reviewsSummary.totalFourStars},${reviewsSummary.totalFiveStars}`;
        this.htmlElement.setAttribute(AttributeEnums.ReviewWidgetSummaryFilterComponentBase.ReviewsSummary, reviewsSummaryString);
    }

    updateReviewSummary(reviewsSummary: IReviewsSummary): void {
        this.writeToReviewSummaryFromReviewSummaryAttribute(reviewsSummary);
        this.setReviewSummaryFromReviewSummaryAttribute();
    }
    
    updateBase(reviewsSummary: IReviewsSummary):void{
        this.updateReviewSummary(reviewsSummary);
    }

    dispose()
    {
        try {
            console.log(`ReviewWidgetSummaryFilterComponentBase: dispose`);
           
            if (this.componentOptions) {

                this.componentOptions.forEach(componentOption => {
                    componentOption.dispose();
                });
            }
          
        } catch (error) {
            console.log('ReviewWidgetSummaryFilterComponentBase: dispose ERROR', error);
        }
    }
}